<template>
    <section class="mine-coupon">
        <div v-if="couponList.length">
          <div class="mine-itemWrapper"
            v-for="item in couponList"
            :key="item.id"
          >
            <coupon :coupon="item" :isVipUser="isVipUser"/>
          </div>
        </div>
        <div class="mine-no-coupon" v-else>
            <img :src="image" alt="noCourse" />
        </div>
    </section>
</template>

<script>
  import Coupon from '../components/Mine/Coupon.vue'
  import api from "../lib/api"

  export default {
    name: 'MineCoupon',
    data () {
      return {
        isVipUser: 0
      }
    },
    computed: {
      image () {
        return this.couponList.length > 0 ? '' : require('../assets/images/coupon_empty.png')
      }
    },
    props: {
      couponList: {
        type: Array,
        default: () => { return [] }
      }
    },
    components: {
      Coupon
    },
    mounted() {
        this.isVip()
    },
    methods: {
      async isVip () {
        try {
          const { data } = await api.privilege.getPrivilegeInfo()
          if (data) {
            this.isVipUser = data.isBuy
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style lang="scss">
    @import '../style/main';

    .mine-coupon {
        padding: rem(15) 0;
        min-height: 100%;
        background-color: #f3f4f6;
        overflow: hidden;
    }

    .mine-no-coupon {
        text-align: center;
        padding: rem(120) 0;

        img {
            height: rem(258);
            width: rem(241);
        }
    }
</style>
